import React from "react";
import { useHistory } from "react-router-dom";

import CustomButton from "../../../../components/customButton";
import InitiateBroadcastIcon from "../../../../images/broadcast/initiate-broadcast.png";
import "./styles.scss";

const InitiateBroadcast = (props) => {
  const { heading, handleResend } = props;

  const history = useHistory();

  const handleStatusUpload = async () => {
    history.push("/broadcast/report");
  };

  return (
    <section className="initiate-broadcast-container">
      <figure className="initiate-broadcast-image">
        <img src={InitiateBroadcastIcon} alt=" " />
      </figure>

      <p className="heading">{heading}</p>

      <p className="description">
        Broadcast initiated successfully for the selected group.
      </p>

      <div className="buttons-container">
        <CustomButton
          className="cancel-button"
          title="Send Another Message"
          onClick={handleResend}
        />

        <CustomButton
          htmlType="submit"
          type="primary"
          title="Check Status Report"
          onClick={handleStatusUpload}
          className="submit-button"
        />
      </div>
    </section>
  );
};

export default InitiateBroadcast;
